import CommonMultilingual from '~~utils/Multilingual';

const localMapping = {
  COLUMN: {
    NAME: {
      'zh-TW': '姓名',
      en: 'Name',
    },
    NUMBER: {
      'zh-TW': '背號',
      en: 'Number',
    },
    BIRTHDAY: {
      'zh-TW': '生日',
      en: 'Birthday',
    },
    FIRST_POSITION: {
      'zh-TW': '主要守位',
      en: 'Main Position',
    },
    SECOND_POSITION: {
      'zh-TW': '次要守位',
      en: 'Second Position',
    },
    P_HAND: {
      'zh-TW': '投球用手',
      en: 'Pitching Hand',
    },
    B_HAND: {
      'zh-TW': '打擊用手',
      en: 'Batting Hand',
    },
  },
  POSITION: {
    P: {
      'zh-TW': '投',
      en: 'P',
    },
    C: {
      'zh-TW': '捕',
      en: 'C',
    },
    '1B': {
      'zh-TW': '一壘',
      en: '1B',
    },
    '2B': {
      'zh-TW': '二壘',
      en: '2B',
    },
    '3B': {
      'zh-TW': '三壘',
      en: '3B',
    },
    SS: {
      'zh-TW': '游擊',
      en: 'SS',
    },
    LF: {
      'zh-TW': '左外野',
      en: 'LF',
    },
    CF: {
      'zh-TW': '中外野',
      en: 'CF',
    },
    RF: {
      'zh-TW': '右外野',
      en: 'RF',
    },
    DH: {
      'zh-TW': '指定打擊',
      en: 'DH',
    },
    IF: {
      'zh-TW': '內野',
      en: 'InField',
    },
    OF: {
      'zh-TW': '外野',
      en: 'OutField',
    },
    UNSET: {
      'zh-TW': '未設定',
      en: 'Unset',
    },
  },
  HAND: {
    R: {
      'zh-TW': '右',
      en: 'Right',
    },
    L: {
      'zh-TW': '左',
      en: 'Left',
    },
    BOTH: {
      'zh-TW': '無限制',
      en: 'Both',
    },
    UNSET: {
      'zh-TW': '未設定',
      en: 'Unset',
    },
  },
  PRE_TOURN_RECORDED_PLAYERS: {
    'zh-TW': '獲取有紀錄的球員',
    en: 'Get recorded players',
  },
  RECORD_CONNECTION: {
    'zh-TW': '歷史紀錄綁定',
    en: 'Record Connection',
  },
  RECORD_CONNECTION_DESCRIPTION: {
    'zh-TW': '我們找到 "可能" 相同的球員，請協助我們確認以利串聯',
    en: 'We found several "possible" equal player, please help us for making connection',
  },
  RECENT_RECORD: {
    'zh-TW': '近期紀錄',
    en: 'Recent Record',
  },
  LINK_THEN_REGISTRY: {
    'zh-TW': '綁定後註冊',
    en: 'Link & Registry',
  },
  SYSTEM_AUTO_DETERMINE: {
    'zh-TW': '系統自動判定',
    en: 'System Auto Determine',
  },
  NO_RECORD: {
    'zh-TW': '無紀錄',
    en: 'No Record',
  },
  DELETE_PLAYER: {
    'zh-TW': '刪除球員',
    en: 'Delete Player',
  },
  JOINED_AND_DELETE_DENY: {
    'zh-TW': '此球員已參與賽事中的比賽，不得刪除（請先移除比賽紀錄）',
    en: 'The player already has record in this tournament. Remove the record before delete',
  },
  CROSS_LEAGUE_DENY_WORDING: {
    'zh-TW': '此球員有參與其他主辦賽事，不得修改個人資料',
    en: 'Player joined multi tournaments, personal profile is locked',
  },
  ASSIGN_MANAGER: {
    'zh-TW': '指派用戶認領',
    en: 'Assign User to Manage',
  },
  ASSIGN_DESCRIPTION: {
    'zh-TW': '指派用戶認領後，用戶將能夠自行更新球員資訊',
    en: 'User can update player profile by themselves after assigning manager',
  },
  ASSIGN_QUERY_HINT: {
    'zh-TW': '輸入 email 或 用戶名稱',
    en: 'input email or username',
  },
  MANAGER_CHECK: {
    'zh-TW': '檢查',
    en: 'Check',
  },
  ASSIGN_CONFIRM: {
    'zh-TW': '確認指派',
    en: 'Assign Confirm',
  },
  SUCCESSFULLY_ASSIGN: {
    'zh-TW': '成功指派！',
    en: 'Successfully Assign!',
  },
  ERROR: {
    NUMBER_DUPLICATE: {
      'zh-TW': '背號重覆',
      en: 'Number Duplicate',
    },
    NAME_NUMBER_REQUIRED: {
      'zh-TW': '姓名、背號為必填',
      en: 'Name & Number are required',
    },
    MANAGER_NOT_FOUND: {
      'zh-TW': '找不到對應用戶',
      en: 'User Not Found',
    },
  },
};

const Multilingual = (textCode, lang = '') => {
  return CommonMultilingual(textCode, localMapping, lang);
};
export default Multilingual;
